/* eslint-disable max-len */
import buttons from './orders/buttons';
import view from './orders/view';
import events from './orders/events';
import filters from './orders/filters';
import list from './orders/list';
import print from './orders/print';
import products from './orders/products';
import test from './orders/test';
import modals from '@/locales/en/orders/modals';

export default {
    acceptanceActsFields: {
        orderId: 'Order number',
        number: 'APP Number',
        dateFormed: 'Date and time of printing',
        deliveryServiceType: 'Delivery service',
        initiator: 'Initiator',
    },

    buttons,

    events,

    filters,

    list,

    print,

    products,

    tare: {
        title: 'Packaging containers',
        column1: 'Type of container',
        column2: 'Weight, kg',
        textDanger: '(Not used)',
        alert: 'It is necessary to specify the weight for each packaging container!',
        maxWeight: 'The weight of the box exceeded the allowable weight of the courier service. The maximum allowable weight is {max} kg. Cancel the current government?',
    },

    test,

    view,

    createRefund: 'Initiate a refund',
    createRefundTitle: 'Do you really want to initiate a refund?',

    item: {
        label: 'Changes are agreed',
        confirm: 'Are you sure you want to change the order status?',
    },

    viewTitle: 'Order № {id}',

    modals,
};